import { Box, Typography } from '@mui/material';

/**
 * Unified card header component for consistent styling across all cards
 * @param {string} title - The header title text
 * @param {React.ReactNode} icon - Optional icon to display before the title
 * @param {React.ReactNode} action - Optional action element (button, etc.) on the right
 * @param {boolean} borderBottom - Whether to show bottom border (default: true)
 */
export default function CardHeader({ title, icon, action, borderBottom = true }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 2.5,
        borderBottom: borderBottom ? 1 : 0,
        borderColor: 'divider',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: 'text.primary',
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {icon}
        {title}
      </Typography>
      {action}
    </Box>
  );
}
